import querystring from 'query-string';

import Urls from '../definitions/Urls';
import Api from '../api/Api';

class SessionUtils {
  static logout(redirectQueryParams) {
    // post to logout
    Api.apiLogout(redirectQueryParams)
      .then((data) => {
        window.location = data;
      })
      .catch((err) => {
        let redirectUrl;
        // TODO: these should use dynamic query param key
        //  - kc uses "logout", shibboleth uses "return"
        if (redirectQueryParams) {
          redirectUrl =
            Urls.logoutFallback() +
            '?return=' +
            encodeURIComponent(
              Urls.logoutFallbackRedirect() +
                '?' +
                querystring.stringify(redirectQueryParams)
            );
        } else {
          redirectUrl =
            Urls.logoutFallback() +
            '?return=' +
            encodeURIComponent(Urls.logoutFallbackRedirect());
        }
        window.location = redirectUrl;
      });
  }
}

export default SessionUtils;
